import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './assets/fonts/font.scss';
import 'antd/dist/reset.css';
import '@/style/base.scss';
import '@/style/ui-modern.scss';
import '@/style/public.scss';
import '@/style/responsive.scss';
import { ConfigProvider } from 'antd';
import store from './store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import Utils from './utils/format';
import { AliveScope } from 'react-activation';
(window as any).utils = Utils;
const persistor = persistStore(store);
// react-activation is incompatible with React 18 createRoot (its README says to use
// the legacy ReactDOM.render). With createRoot, KeepAlive-cached pages come back with
// dead refs: Selects/inputs stop working and Popovers crash with "reading 'focus'".
ReactDOM.render(
    <Provider store={store}>
        {/* <React.StrictMode> */}
        <PersistGate loading={null} persistor={persistor}>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#052588',
                        colorLink: '#052588',
                        borderRadius: 10,
                        borderRadiusLG: 12,
                        controlHeight: 44,
                        fontSize: 14,
                        motionDurationMid: '0.2s',
                        colorBorder: '#e8ecf3',
                        colorSplit: '#eef1f6',
                    },
                    components: {
                        Button: {
                            controlHeight: 44,
                            borderRadius: 10,
                        },
                        Modal: {
                            borderRadiusLG: 16,
                        },
                    },
                }}
            >
                <AliveScope>
                    <App />
                </AliveScope>
            </ConfigProvider>
        </PersistGate>
        {/* </React.StrictMode> */}
    </Provider>,
    document.getElementById('root')
);
